import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  setBrandDiscount,
  setBrandDiscountList,
  setIsWaitingBrandDiscountGetResponse,
  setIsWaitingBrandDiscountPostResponse,
  setIsWaitingBrandDiscountPutResponse,
} from "../slices/brandDiscountSlice";
import { getApiUrl } from "../helpers/environmentHelper";
import { BrandDiscount } from "../../models/responses/brandDiscount";
import { get } from "http";
import { handleFloatToInt } from "./calculationsHelperService";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getBrandDiscounts =
  (instance: IPublicClientApplication, account: AccountInfo | null) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingBrandDiscountGetResponse(true));
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: BrandDiscount[] = (
                  await axios.get(`${baseUrl}/branddiscounts`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setBrandDiscountList({ brandDiscounts: getData }));
                dispatch(setIsWaitingBrandDiscountGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingBrandDiscountGetResponse(false));
        console.log(error);
      }
    };

export const getBrandDiscountById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      if (!id) return;
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingBrandDiscountGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: BrandDiscount = (
                  await axios.get(`${baseUrl}/branddiscounts/${id}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                console.log(getData);
                dispatch(setBrandDiscount({ brandDiscount: getData }));
                dispatch(setIsWaitingBrandDiscountGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingBrandDiscountGetResponse(false));
        console.log(error);
      }
    };

export const getBrandDiscountByCarBrandId =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    carBrandId: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      console.log("Gettings price", carBrandId);

      if (!carBrandId || carBrandId === "") return;
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingBrandDiscountGetResponse(true));
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: BrandDiscount = (
                  await axios.get(
                    `${baseUrl}/branddiscounts/carbrand/${carBrandId}`,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  )
                ).data;
                dispatch(setBrandDiscount({ brandDiscount: getData }));
                dispatch(setIsWaitingBrandDiscountGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingBrandDiscountGetResponse(false));
        console.log(error);
      }
    };

export const postBrandDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    brandDiscount: BrandDiscount,
    onSuccess: (brandDiscountId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      dispatch(setIsWaitingBrandDiscountPostResponse(true));
      let dto = { ...brandDiscount };
      dto = handleBrandDiscountForRequest(dto);

      const baseUrl = getApiUrl(window.location.hostname, 2);
      let responseId: string | null = null;
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.post(
                    `${baseUrl}/branddiscounts`,
                    dto,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );

                  if (responseData.status === 201) {
                    let locationArray =
                      responseData.headers["location"].split("/");
                    responseId = locationArray[locationArray.length - 1];
                  }
                }
              } finally {
                onSuccess(responseId);
                dispatch(setIsWaitingBrandDiscountPostResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };

export const putBrandDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    brandDiscount: BrandDiscount,
    onSuccess: (brandDiscountId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingBrandDiscountPutResponse(true));
      let dto = { ...brandDiscount };
      dto = handleBrandDiscountForRequest(dto);
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.put(
                    `${baseUrl}/branddiscounts`,
                    dto,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );
                  if (responseData.status === 204) {
                    onSuccess(dto.id);
                  }
                }
              } finally {
                dispatch(setIsWaitingBrandDiscountPutResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };

const handleBrandDiscountForRequest = (
  discount: BrandDiscount
): BrandDiscount => {
  discount = {
    ...discount,
    workshopSalesDiscount: handleFloatToInt(
      parseFloat(discount.workshopSalesDiscount)
    ),
    storeDiscount: handleFloatToInt(parseFloat(discount.storeDiscount)),
  };
  return discount;
};
